export default "__VITE_ASSET__7e4_Pt5Q__"